import { render, staticRenderFns } from "./CaixaFechamento.vue?vue&type=template&id=61e8e33c&"
import script from "./CaixaFechamento.vue?vue&type=script&lang=js&"
export * from "./CaixaFechamento.vue?vue&type=script&lang=js&"
import style0 from "./CaixaFechamento.vue?vue&type=style&index=0&id=61e8e33c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports